import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'locales/i18n'
import withStyles from 'react-jss'
import compose from '@shopify/react-compose'

import config from 'config'

import withConfiguration from 'components/providers/configuration/with-configuration'
import localesStyles from './locales-style'


const handleChangeLocale = e => {
  i18n.changeLanguage(e.target.value)
  config.set('LOCALE', e.target.value)
}

const filterSupportedLocales = ({ portalConfiguration }) => {
  const locales = portalConfiguration.supported_locales || ["fr", "en", "es", "de", "it", "zh"]
  return Object.keys(i18n.options.resources).filter(locale => locales.indexOf(locale) > -1)
}

const Locales = props =>
  <div className={props.classes.localesContainer}>
    <select value={i18n.language} onChange={handleChangeLocale} className={props.classes.selector}>
      {filterSupportedLocales(props).map(locale =>
        <option key={locale}>{locale}</option>
      )}
    </select>
    <span className={props.classes.selectorArrow} />
  </div>

Locales.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default compose(
  withStyles(localesStyles),
  withConfiguration,
)(Locales)
